export default "__VITE_ASSET__FxviyJ8o__"